import type { VisibleWorkflowWindow, WorkflowStep } from './types'

export function getVisibleSteps(
  steps: WorkflowStep[],
  currentIndex: number | null,
  windowBefore = 2,
  windowAfter = 2,
): VisibleWorkflowWindow {
  if (steps.length === 0) {
    return {
      steps: [],
      startIndex: 0,
      endIndex: -1,
      hasLeadingEllipsis: false,
      hasTrailingEllipsis: false,
      currentIndex,
    }
  }

  const idx = currentIndex ?? 0
  const startIndex = Math.max(0, idx - windowBefore)
  const endIndex = Math.min(steps.length - 1, idx + windowAfter)

  return {
    steps: steps.slice(startIndex, endIndex + 1),
    startIndex,
    endIndex,
    hasLeadingEllipsis: startIndex > 0,
    hasTrailingEllipsis: endIndex < steps.length - 1,
    currentIndex,
  }
}
